import type { BestMatchesDto, ChatDto, JobPreviewDto } from './chat.dto';

import { toCandidateViewModel, type CandidateViewModel } from '@/entities/candidate';
import { JobViewModel, toJobViewModel } from '@/entities/job';

export type ChatViewModel = {
  id: number;
  name: string | null;
  jobPreview: string | null;
  campaignId: number | null;
  job: JobViewModel;
  jobImprovedId: number | null;
};

export type BestMatchesViewModel = {
  candidates: CandidateViewModel[];
  total: number;
};

export type JobPreviewViewModel = {
  chatId: number;
  text: string;
};

export const toChatViewModel = (data: ChatDto): ChatViewModel => {
  return {
    id: data.chat.id,
    name: data.job.job_title ?? null,
    jobPreview: data.job.job_preview ?? null,
    campaignId: data.chat.campaign ?? null,
    job: toJobViewModel(data.job),
    jobImprovedId: data.chat.job_improved_id ?? null,
  };
};

export const toBestMatchesViewModel = (data: BestMatchesDto): BestMatchesViewModel => {
  return {
    candidates: data.search_results.hits.hits.map(toCandidateViewModel),
    total: data.search_results.hits.total.value,
  };
};

export const toJobPreviewViewModel = (data: JobPreviewDto): JobPreviewViewModel => {
  return {
    chatId: data.chat_id,
    text: data.preview_text,
  };
};
